import { render } from "./RegionSelector.vue?vue&type=template&id=4edd1128&scoped=true"
import script from "./RegionSelector.vue?vue&type=script&lang=js"
export * from "./RegionSelector.vue?vue&type=script&lang=js"

import "./RegionSelector.vue?vue&type=style&index=0&id=4edd1128&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edd1128"]])

export default __exports__